export var DefaultTabKey;
(function (DefaultTabKey) {
    DefaultTabKey["house_tab"] = "house_tab";
    DefaultTabKey["heat_tab"] = "heat_tab";
    DefaultTabKey["guard_tab"] = "guard_tab";
    DefaultTabKey["control_tab"] = "control_tab";
    DefaultTabKey["custom_tab"] = "custom_tab";
    DefaultTabKey["vehicle_tab"] = "vehicle_tab";
    DefaultTabKey["eventsTab"] = "eventsTab";
    DefaultTabKey["graphs"] = "graphs";
    DefaultTabKey["dashboard"] = "dashboard";
    DefaultTabKey["gtw-main"] = "gtw-main";
    DefaultTabKey["gtw-state"] = "gtw-state";
    DefaultTabKey["thermostat"] = "thermostat";
    DefaultTabKey["diagnostics"] = "diagnostics";
    DefaultTabKey["reports"] = "reports";
    DefaultTabKey["maintenance"] = "maintenance";
    DefaultTabKey["cams"] = "cams";
    DefaultTabKey["map"] = "map";
    DefaultTabKey["terminal"] = "terminal";
    DefaultTabKey["sockets"] = "sockets";
})(DefaultTabKey || (DefaultTabKey = {}));
